import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { ArrowRight, Zap } from 'lucide-react';

const LandingCTA = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <section className="py-20 sm:py-28 px-4">
      <div className="max-w-3xl mx-auto text-center space-y-6">
        <div className="mx-auto w-16 h-16 rounded-2xl bg-primary/10 flex items-center justify-center">
          <Zap className="h-8 w-8 text-primary" />
        </div>
        <h2 className="text-3xl sm:text-4xl font-bold">{t('landing.readyToEnd')}</h2>
        <p className="text-muted-foreground text-lg max-w-xl mx-auto">
          {t('landing.setupIn2Min')}
        </p>
        <Button size="lg" className="text-base px-10 h-12 rounded-xl shadow-lg shadow-primary/25" onClick={() => navigate('/auth')}>
          {t('landing.startFamilyHub')}
          <ArrowRight className="ms-2 h-4 w-4" />
        </Button>
      </div>
    </section>
  );
};

export default LandingCTA;
